<section class="footer">
  <div class="wrapper">
    <nav class="footer-nav">
      <ng-container *ngFor="let menuElem of menuFooter$ | async">
        <a [routerLink]="['/', menuElem.slug]" class="footer-nav-item">{{ menuElem.name }}</a>
      </ng-container>
    </nav>
  </div>
</section>
